import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "Sky High NTB";
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://skyhighntb.com";

const generateSupportNotificationHTML = (userData) => {
  const userLink = `${BASE_URL}/userdetail/${userData.uid}`;
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header {  background: linear-gradient(to right, #8b0000, #dc143c); color: #ffffff; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
        .info-box { background: #f8f9fa; padding: 10px; border-radius: 8px; margin: 10px 0; }
        .info-box p { margin: 10px 0; }
        .label { font-weight: bold; color: #2C3D4F; }
        .btn { display: inline-block; padding: 12px 30px; background: #2C3D4F; color: #ffffff; text-decoration: none; border-radius: 5px; margin: 20px 0; }
        .footer { text-align: center; padding: 20px; color: #888; font-size: 12px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>New User Registration</h1>
        </div>
        <div class="content">
          <p>A new user has registered on ${BRAND_NAME}.</p>
          
          <div class="info-box">
            <p><span class="label">Full Name:</span> ${userData.fullName}</p>
            <p><span class="label">Email:</span> ${userData.email}</p>
            <p><span class="label">Address:</span> ${userData.address}</p>
            <p><span class="label">Referred By:</span> ${userData.referrerName || "N/A"}</p>
          </div>
          
          <div style="text-align: center;">
            <a href="${userLink}" class="btn">View & Edit User</a>
          </div>
        </div>
        <div class="footer">
          <p>${BRAND_NAME} Admin Notification</p>
        </div>
      </div>
    </body>
    </html>
  `;
};

const generateWelcomeEmailHTML = (userData) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(135deg, #8b0000 0%, #dc143c 100%); color: #ffffff; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { padding: 30px; color: #333; }
        .btn { display: inline-block; padding: 12px 30px; background: #2C3D4F; color: #ffffff; text-decoration: none; border-radius: 5px; margin: 20px 0; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .info-box p { margin: 10px 0; }
        .label { font-weight: bold; color: #2C3D4F; }
        .footer { text-align: center; padding: 20px; color: #888; font-size: 12px; }
        .social-links { margin-top: 15px; }
        .social-links a { color: #2C3D4F; text-decoration: none; margin: 0 10px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>Welcome to ${BRAND_NAME}!</h1>
        </div>
        <div class="content">
          <p>Hello <strong>${userData.fullName}</strong>,</p>
          <p>Welcome to ${BRAND_NAME}! We're thrilled to have you on board.</p>
          
          <div class="info-box">
            <p><span class="label">Your Account Number:</span> ${userData.accountNumber}</p>
            <p><span class="label">Your Security Code:</span> ${userData.code}</p>
          </div>
          
          <p>Please keep your account credentials safe. You will need your account number and security code to access your account.</p>
          
          <p>If you have any questions or need assistance, feel free to reach out to our support team.</p>
          
      </div>
    </body>
    </html>
  `;
};

export const sendRegistrationNotificationToSupport = async (userData) => {
  console.log("📧 Sending support notification...", { SUPPORT_EMAIL, userData });
  try {
    const html = generateSupportNotificationHTML(userData);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: "Admin",
        user_email: SUPPORT_EMAIL,
        html: html,
      },
      PUBLIC_KEY
    );
    console.log("✅ Support notification sent:", response);
    return true;
  } catch (error) {
    console.error("❌ Error sending support notification:", error);
    return false;
  }
};

export const sendWelcomeEmailToUser = async (userData) => {
  console.log("📧 Sending welcome email to user...", { email: userData.email });
  try {
    const html = generateWelcomeEmailHTML(userData);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: userData.fullName,
        user_email: userData.email,
        html: html,
      },
      PUBLIC_KEY
    );
    console.log("✅ Welcome email sent to user:", response);
    return true;
  } catch (error) {
    console.error("❌ Error sending welcome email:", error);
    return false;
  }
};

export const sendBothEmails = async (userData) => {
  const supportResult = await sendRegistrationNotificationToSupport(userData);
  const userResult = await sendWelcomeEmailToUser(userData);
  return supportResult && userResult;
};